module.exports = __webpack_public_path__ + "static/media/new-year-giveaway.16bf67af.jpg";